import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { DanhMucService, KhachHangTreoThaoService, DatetimeService, UserService } from '../../../../services/index'
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { Message } from 'primeng/components/common/message';

import { environment } from 'environments/environment';
const userLocalName = environment.LOCAL_USER_NAME;

@Component({
  selector: 'app-thongtincto',
  templateUrl: './thongtincto.component.html',
  styleUrls: ['./thongtincto.component.scss'],

  encapsulation: ViewEncapsulation.None
})
export class ThongTinCtoComponent implements OnInit {

  constructor(
    private danhMucService: DanhMucService,
    private treothaoService: KhachHangTreoThaoService,
    private datetimeService: DatetimeService,
    private user: UserService,
    private confirmationService: ConfirmationService) {
    this.modelCto[0] = [];
  }

  @Input() meterid: number;
  @Input() action: string;
  @Output() reloadDsKH = new EventEmitter();

  modelCto: any = [];
  subscription: Subscription;
  isShowProgress = 0;
  msgs: Message[] = [];

  //Danh sách chủng loại
  listChungLoai: any = [];

  //Danh sách loại module RF
  listLoaiRF: any = [];

  //Index công tơ được chọn
  congtoIndex: number = 0;

  isApproveSua = false;
  taiLaiDS_KH() {
    this.reloadDsKH.emit(null)
  }

  ngOnInit() {

    this.isShowProgress = 1;

    this.modelCto[0].ngaylap = new Date();
    this.modelCto[0].ngaynghiemthu = new Date();
    this.modelCto[0].ngaythanhly = new Date();
    this.modelCto[0].ngaymatdien = new Date();
    this.laydulieu();

  }

  thaydoiTU_TI_Ngoai() {
    this.modelCto[this.congtoIndex].hsnhan_ngoai = this.modelCto[this.congtoIndex].tu_ngoai * this.modelCto[this.congtoIndex].ti_ngoai;

    if (isNaN(this.modelCto[this.congtoIndex].hsnhan_ngoai))
      this.modelCto[this.congtoIndex].hsnhan_ngoai = "";
  }

  //Lấy danh sách chủng loại
  layDS_ChungLoai() {
    this.treothaoService.layDanhSachLoaiCongTo().subscribe(response => {
      var res = (response).result;
      if (res == "OK") {
        let ret = (response).data;
        this.listChungLoai = ret[0].result_table_0;
        this.listLoaiRF = ret[1].result_table_1;


        if (this.listChungLoai.some(x => x.loaicongto == this.modelCto[this.congtoIndex].loaicongto)) {
          this.nhasanxuat = this.listChungLoai.find(x => x.loaicongto == this.modelCto[this.congtoIndex].loaicongto).nhasanxuat;
        }
      }
    });
  }
  nhasanxuat: string = '';
  //Thay đổi loại công tơ
  thaydoiLoaiCongTo() {
    let mk = this.listChungLoai.find(x => x.loaicongto == this.modelCto[this.congtoIndex].loaicongto).matkhaucongto;
    this.nhasanxuat = this.listChungLoai.find(x => x.loaicongto == this.modelCto[this.congtoIndex].loaicongto).nhasanxuat;

    this.modelCto[this.congtoIndex].matkhaucongto = mk;
  }


  laydulieu() {

    this.isShowProgress = 1;
    this.msgs = [];
    this.treothaoService.layTT_Cto(this.meterid).subscribe(res => {
      let dataRet = (res);
      if (dataRet.data.length > 0) {
        this.modelCto = dataRet.data;
        this.layDS_ChungLoai();
        this.modelCto.push([]);
        this.modelCto[this.congtoIndex].loaicongto = this.modelCto[this.modelCto.length - 2].loaicongto;
        if (this.action == 'thay')
          this.hienThayCT()
      }
      else {
      }
      this.isShowProgress = 0
      this.msgs = [];
    });

  }


  luuTT_CT() {
    this.user.kiemTraQuyen(17).subscribe(
      res => {
        let data = (res).data;
        if (data.length > 0) {
          if (data[0].sua > 0) {
            this.msgs = [];
            let bl = window.confirm("Lưu thông tin công tơ ?");
            if (bl) {

              this.isShowProgress = 1;
              let curUser = JSON.parse(localStorage.getItem(userLocalName));
              this.treothaoService.suaTT_CT(
                this.modelCto[this.congtoIndex].meterid,
                this.modelCto[this.congtoIndex].socongto,
                this.modelCto[this.congtoIndex].tu_ngoai,
                this.modelCto[this.congtoIndex].ti_ngoai,
                this.modelCto[this.congtoIndex].hsnhan_ngoai,
                this.modelCto[this.congtoIndex].loaicongto,
                this.modelCto[this.congtoIndex].matkhaucongto,
                this.modelCto[this.congtoIndex].matkhaucongto2,
                this.modelCto[this.congtoIndex].outstation,
                this.modelCto[this.congtoIndex].loaiheso,
                this.modelCto[this.congtoIndex].hangso,
                this.modelCto[this.congtoIndex].offset,
                this.modelCto[this.congtoIndex].cs_treo,
                this.modelCto[this.congtoIndex].cs_thao,
                this.modelCto[this.congtoIndex].bt_treo,
                this.modelCto[this.congtoIndex].bt_thao,
                this.modelCto[this.congtoIndex].cd_treo,
                this.modelCto[this.congtoIndex].cd_thao,
                this.modelCto[this.congtoIndex].td_treo,
                this.modelCto[this.congtoIndex].td_thao,
                this.modelCto[this.congtoIndex].sg_treo,
                this.modelCto[this.congtoIndex].sg_thao,
                this.modelCto[this.congtoIndex].vc_treo,
                this.modelCto[this.congtoIndex].vc_thao,
                this.modelCto[this.congtoIndex].loai_module,
                curUser.mataikhoan,
                ''
              ).subscribe(res => {
                let dataRet = (res);
                if (dataRet.result == 'OK' && dataRet.data[0].result == 'OK') {
                  this.msgs.push({ severity: 'success', summary: 'Thông báo', detail: 'Lưu thông tin công tơ thành công' });
                }
                else {
                  this.msgs.push({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lưu dữ liệu: ' + dataRet.data });
                }
                this.isShowProgress = 0;
                this.taiLaiDS_KH();
              });
            }
          } else {
            alert("Bạn không có quyền thực hiện chức năng này!");
          }

        }
        else {
          alert("Bạn không có quyền thực hiện chức năng này!");
        }
      }
    )

  }

  hienThayCT() {
    this.congtoIndex = this.modelCto.length - 1;
  }
  thayCT() {
    this.user.kiemTraQuyen(17).subscribe(
      res => {
        let data = (res).data;
        if (data.length > 0) {
          if (data[0].sua > 0) {
            this.msgs = [];
            if (this.modelCto[0].socongto_dangtreo == this.modelCto[this.congtoIndex].socongto) {
              this.msgs.push({ severity: 'error', summary: 'Thông báo', detail: 'Số công tơ mới trùng số công tơ cũ' });
              return;
            }
            let bl = window.confirm("Thay công tơ cho điểm đo này ?");
            if (bl) {
              this.isShowProgress = 1;
              let curUser = JSON.parse(localStorage.getItem(userLocalName));
              this.treothaoService.thayCT(
                this.modelCto[0].meterid,
                this.modelCto[0].socongto_dangtreo,
                this.modelCto[this.congtoIndex].socongto,
                this.modelCto[this.congtoIndex].loaicongto,
                this.modelCto[this.congtoIndex].hangso == undefined ? '' : this.modelCto[this.congtoIndex].hangso,
                this.modelCto[this.congtoIndex].offset == undefined ? '' : this.modelCto[this.congtoIndex].offset,
                this.modelCto[this.congtoIndex].cs_treo == undefined ? '' : this.modelCto[this.congtoIndex].cs_treo,
                this.modelCto[this.congtoIndex].cs_thao == undefined ? '' : this.modelCto[this.congtoIndex].cs_thao,
                this.modelCto[this.congtoIndex].bt_treo == undefined ? '' : this.modelCto[this.congtoIndex].bt_treo,
                this.modelCto[this.congtoIndex].bt_thao == undefined ? '' : this.modelCto[this.congtoIndex].bt_thao,
                this.modelCto[this.congtoIndex].cd_treo == undefined ? '' : this.modelCto[this.congtoIndex].cd_treo,
                this.modelCto[this.congtoIndex].cd_thao == undefined ? '' : this.modelCto[this.congtoIndex].cd_thao,
                this.modelCto[this.congtoIndex].td_treo == undefined ? '' : this.modelCto[this.congtoIndex].td_treo,
                this.modelCto[this.congtoIndex].td_thao == undefined ? '' : this.modelCto[this.congtoIndex].td_thao,
                this.modelCto[this.congtoIndex].sg_treo == undefined ? '' : this.modelCto[this.congtoIndex].sg_treo,
                this.modelCto[this.congtoIndex].sg_thao == undefined ? '' : this.modelCto[this.congtoIndex].sg_thao,
                this.modelCto[this.congtoIndex].vc_treo == undefined ? '' : this.modelCto[this.congtoIndex].vc_treo,
                this.modelCto[this.congtoIndex].vc_thao == undefined ? '' : this.modelCto[this.congtoIndex].vc_thao,
                this.nhasanxuat == 'PSMART' ? (this.modelCto[this.congtoIndex].loai_module == undefined ? '' : this.modelCto[this.congtoIndex].loai_module) : '',
                curUser.mataikhoan,
                ''
              ).subscribe(res => {
                let dataRet = (res);
                if (dataRet.result == 'OK' && dataRet.data[0].result == 'OK') {
                  //this.laydulieu();
                  this.msgs.push({ severity: 'success', summary: 'Thông báo', detail: 'Thay công tơ thành công' });
                }
                else {
                  this.msgs.push({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lưu dữ liệu: ' + dataRet.data[0].result });
                }
                this.isShowProgress = 0;
                this.taiLaiDS_KH();
              });
            }
          } else {
            alert("Bạn không có quyền thực hiện chức năng này!");
          }

        }
        else {
          alert("Bạn không có quyền thực hiện chức năng này!");
          return;
        }
      }
    )

  }

  selectCT(idx) {
    if (this.congtoIndex != this.modelCto.length - 1)
      this.congtoIndex = idx;
  }
}






// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/nhap-thong-tin-kh/khach-hang-treo-thao/thong-tin-cto/thongtincto.component.ts